import DirectorInfoPanel from 'modules/Business/containers/Director/DirectorInfoPanel';
import DirectorForm from 'modules/Business/containers/Director/DirectorsForm';
import { Box, theme, Typography, useLayout } from '@capitalise/ui-design-system';
import useMediaQuery from 'modules/Business/hooks/useMediaQuery';

export interface DirectorFormData {
  name: string;
  dateOfBirth: string;
  houseNumber: string;
  street: string;
  town: string;
  postCode: string;
  consent: boolean;
}

export interface DirectorConsentFormProps {
  isError: boolean;
  error?: { message?: string };
  isLoading: boolean;
  onSubmit: (data: DirectorFormData) => void;
  origin: string;
  prev: any;
}

const DirectorConsentForm = ({
  onSubmit,
  isError,
  error,
  isLoading,
  origin,
  prev
}: DirectorConsentFormProps) => {
  const { setRightBarOverlay } = useLayout();
  const { isMobile } = useMediaQuery();

  const openSidePanel = () => {
    setRightBarOverlay(
      <DirectorInfoPanel />,
      { size: isMobile ? 'fullWidth' : 'xlarge' },
      {
        shouldBeOnTop: true,
      },
    );
  };

  return (
    <>
      <Box marginBottom="3xsmall" marginTop="xsmall">
        <Typography size="heading-28">
          Verify a company director to access your company&rsquo;s full Experian data{' '}
        </Typography>
      </Box>
      <Box marginBottom="medium">
        <Typography size="body-16">
          This is required for verification purposes only to provide you with your company&rsquo;s
          full Experian data &nbsp;
          <span
            style={{ color: theme.colors['green-500'], cursor: 'pointer' }}
            onClick={openSidePanel}
          >
            Find out more.
          </span>
        </Typography>
      </Box>
      <DirectorForm
        isDirectorConsentFlow
        isError={isError}
        error={error}
        isLoading={isLoading}
        onSubmit={onSubmit}
        buttonSize="medium"
        origin={origin}
        prev={prev}
      />
    </>
  );
};

export default DirectorConsentForm;
